import { all, takeEvery, put, fork, call } from "redux-saga/effects";

import { apiCrawlPlanService, taskService } from "@iso/services";
import actions from "@iso/redux/apiCrawlPlan/actions";
import { LIST_OPEN_SALE_STATUS } from "@iso/constants/api.constant";

function* getListCrawlPlan() {
  yield takeEvery(actions.GET_CRAWL_PLAN_REQUEST, function* ({ payload }) {
    const {
      storeIds,
      keyword,
      keywordType,
      otaIds,
      createdUsers,
      createdAtStart,
      createdAtEnd,
      size,
      page,
      resolve,
      reject,
    } = payload;
    try {
      const response = yield call(apiCrawlPlanService.getListCrawlPlan, {
        storeIds,
        keyword,
        keywordType,
        otaIds,
        createdUsers,
        createdAtStart,
        createdAtEnd,
        size,
        page,
        resolve,
        reject,
      });

      if (response && response.apiCrawlPlans) {
        response.apiCrawlPlans.map((crawlPlan) => {
          crawlPlan.periodDate = null;
          if (crawlPlan
            && crawlPlan.periodStartDate
            && crawlPlan.periodStartDate != null
            && crawlPlan.periodStartDate != undefined
            && crawlPlan.periodEndDate
            && crawlPlan.periodEndDate != null
            && crawlPlan.periodEndDate != undefined
          ) {
            crawlPlan.periodDate = crawlPlan.periodStartDate + ' ～ ' + crawlPlan.periodEndDate
          }

          if (crawlPlan.openSaleStatus
            && crawlPlan.openSaleStatus != ""
            && crawlPlan.openSaleStatus != null
            && crawlPlan.openSaleStatus != undefined
          ) {
            let arrayOpenSale = crawlPlan.openSaleStatus.split(",");
            crawlPlan.openSaleStatus = arrayOpenSale.map(item => {
              const match = LIST_OPEN_SALE_STATUS.find(obj => obj.id === parseInt(item));
              return match ? match.name : item;
            }).join(", ");
          }
        })
      }

      yield put({
        type: actions.GET_CRAWL_PLAN_SUCCESS,
        apiCrawlPlans: response ? response.apiCrawlPlans : [],
        total: response ? response.total : 0
      });
      yield resolve(response.apiCrawlPlans);
    } catch (e) {
      yield put({
        type: actions.GET_CRAWL_PLAN_ERROR,
        error: e.message,
      });
    }
  });
}


function* crawlPlan() {
  yield takeEvery(actions.CRAWL_PLAN_REQUEST, function* ({ payload }) {
    const {
      storeId,
      keyword,
      keywordType,
      otaId,
      columnCrawls,
      typeCrawl,
      crawlPlanId,
      openSaleStatusSearch,
      periodStartDate,
      periodEndDate,
      resolve,
      reject,
    } = payload;
    try {
      const response = yield call(apiCrawlPlanService.crawlPlan, {
        storeId,
        keyword,
        keywordType,
        otaId,
        columnCrawls,
        typeCrawl,
        crawlPlanId,
        openSaleStatusSearch,
        periodStartDate,
        periodEndDate,
        resolve,
        reject,
      });
      yield put({
        type: actions.CRAWL_PLAN_SUCCESS,
      });
      yield resolve(response);
    } catch (e) {
      yield put({
        type: actions.CRAWL_PLAN_ERROR,
        error: e.message,
      });
      reject(e)
    }
  });
}

function* getListUser() {
  yield takeEvery(actions.GET_LIST_USER_REQUEST, function* ({ payload }) {
    const { list_role } = payload;
    try {
      const [assignees] = yield all([
        call(taskService.getAssignees, { list_role }),
      ]);
      yield put({
        type: actions.GET_LIST_USER_SUCCESS,
        listUser: assignees ? assignees.accounts : [],
      });
    } catch (e) {
      yield put({
        type: actions.GET_LIST_USER_ERROR,
        error: e.message,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getListCrawlPlan),
    fork(crawlPlan),
    fork(getListUser),
  ]);
}
